function sort(inA, inB, type) {
  const AFloat = parseFloat(inA);
  const BFloat = parseFloat(inB);
  const isNumber = Boolean(AFloat && BFloat);
  const A = isNumber ? AFloat : inA;
  const B = isNumber ? BFloat : inB;

  const multiplier = type === 'asc' ? 1 : -1;

  return A !== B ? (A > B ? 1 * multiplier : -1 * multiplier) : 0;
}

export function sortStringOrNumber(list, reference, sorting, subReference, subReferenceField) {
  return [...list].sort((a, b) => {
    const referenceValueA = reference[a][sorting.field];
    const referenceValueB = reference[b][sorting.field];
    const A =
      subReference && subReference[referenceValueA]
        ? subReference[referenceValueA][subReferenceField]
        : referenceValueA;
    const B =
      subReference && subReference[referenceValueB]
        ? subReference[referenceValueB][subReferenceField]
        : referenceValueB;
    return sort(A, B, sorting.dir);
  });
}

export function sortTransactionsInvoices(list, invoices, transition, sorting) {
  return [...list].sort((a, b) => {
    const A =
      a.type === 'invoice'
        ? invoices[a.id][sorting.fieldInvoice]
        : transition[a.id][sorting.fieldTransaction];
    const B =
      b.type === 'invoice'
        ? invoices[b.id][sorting.fieldInvoice]
        : transition[b.id][sorting.fieldTransaction];
    return sort(A, B, sorting.dir);
  });
}
